<template>
  <div class="text-left">
    <BreadcrumbsNav />
    <v-row align="center">
      <v-col cols="12" sm="10" class="pb-12">
        <h1 class="text-h4 font-weight-black mb-8">Espace Convive</h1>
        <p>
          Bienvenue dans l'espace dédié aux convives ! Retrouvez ici toutes les informations, conseils et outils pour
          mieux comprendre l'impact de votre consommation et participer à la démarche anti-gaspillage.
        </p>
      </v-col>
      <v-col cols="2">
        <v-img
          src="/static/images/doodles-dsfr/primary/ReadingDoodle.png"
          v-if="$vuetify.breakpoint.smAndUp"
          class="mx-auto rounded-0"
          contain
          max-width="100%"
        ></v-img>
      </v-col>
    </v-row>
    <!-- Section 1: Éco-Score Personnel - Tableau de bord d'impact environnemental individuel -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6">
        <v-img
          src="/static/images/dashboard-convive.png"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
      <v-col cols="12" md="6">
        <h2 class="text-h5 font-weight-bold mb-4">Éco-Score Personnel</h2>
        <p>
          Cette fonctionnalité calcule et affiche l'empreinte carbone, hydrique et l'impact sur la biodiversité de
          chaque repas consommé par le convive. Contrairement aux solutions actuelles qui se contentent d'afficher des
          informations génériques, cette fonction crée un profil personnel avec :
        </p>
        <ul>
          <li>Suivi mensuel de l'impact environnemental de ses choix alimentaires</li>
          <li>Comparaisons avec la moyenne du restaurant et objectifs planétaires</li>
          <li>Suggestions personnalisées pour réduire son impact</li>
          <li>Gamification avec badges et défis éco-responsables</li>
        </ul>
      </v-col>
    </v-row>

    <!-- Section 2: Anti-gaspi participative et suggestions “pratique durable” -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6" order-md="1" order="2">
        <h2 class="text-h5 font-weight-bold mb-4">Anti-gaspi participative et suggestions “pratique durable”</h2>
        <p>
          Cette fonctionnalité permet aux convives de signaler facilement leurs préférences ou leurs “restes” (ex : via
          notre appli mobile ou une borne), ce qui alimente le cuisinier en retour d’expérience concret, et permet
          d’organiser régulièrement des ateliers ou des challenges convives autour de recettes antigaspi ou de pratiques
          alimentaires durables. Cette fonctionnalité vous transforme, vous consommateurs, en acteurs de la démarche
          environnementale, tout en créant du lien autour du projet de restauration collective.
        </p>
      </v-col>
      <v-col cols="12" md="6" order-md="2" order="1">
        <v-img
          src="/static/images/doodles-dsfr/secondary/SprintingDoodle.png"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
    </v-row>

    <!-- Section 3: Circuit Court Social - Traçabilité interactive et engagement communautaire -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6">
        <v-img
          src="/static/images/video-poster-intro.webp"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
      <v-col cols="12" md="6">
        <h2 class="text-h5 font-weight-bold mb-4">Circuit Court Social</h2>
        <p>Cette fonctionnalité connecte les convives aux producteurs locaux et à l'impact de leurs choix :</p>
        <ul>
          <li>Géolocalisation des ingrédients avec portraits des producteurs locaux</li>
          <li>Système de vote pour influencer le menu de demain selon les valeurs durables</li>
          <li>Événements communautaires (rencontres avec producteurs, ateliers zéro déchet)</li>
        </ul>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BreadcrumbsNav from "@/components/BreadcrumbsNav"

export default {
  name: "ConvivePage",
  components: { BreadcrumbsNav },
}
</script>

<style scoped>
.gestionnaire-img {
  max-height: 400px;
  width: auto;
}
@media (max-width: 600px) {
  .gestionnaire-img {
    max-width: 320px;
    height: auto;
    max-height: none;
  }
}
</style>
